import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ContrastIcon(props: IconProps) {
    return <Icon {...props} iconKey={"contrast"}/>
}
